import { useEffect, useRef, useState } from "react";
import * as THREE from "three";

export const useOverview3dBuildingMovement = (buildingsTranslationXInput, buildingsTranslationYInput, buildingsTranslationZInput) => {
    const [movementActive, setMovementActive] = useState(false);

    const cleanUp = useRef();

    const onMovementActive = plot3d => {
        setMovementActive(true);
        const {mount, camera} = plot3d;
        let isDragging = false;
        let oldVector;
        let positionX = buildingsTranslationXInput.value ?? 0;
        let positionY = buildingsTranslationYInput.value ?? 0;
        let positionZ = buildingsTranslationZInput.value ?? 0;

        const onMouseDown = e => {
            if(e.button === 1) {
                isDragging = true;
                const {width, height} = mount.getBoundingClientRect();
                const pointer = new THREE.Vector2();
                // Normalize pointer to [-1, 1] range
                pointer.x = ((e.clientX) / width) * 2 - 1;
                pointer.y = -((e.clientY) / height) * 2 + 1;

                oldVector = new THREE.Vector3(pointer.x, pointer.y, 0);
                oldVector.unproject(camera); // Convert to world space
            }
        };

        mount.addEventListener("mousedown", onMouseDown);

        const onMouseMove = e => {
            if (!isDragging) {
                return;
            };

            const {width, height} = mount.getBoundingClientRect();
            const pointer = new THREE.Vector2();
            // Normalize pointer to [-1, 1] range
            pointer.x = ((e.clientX) / width) * 2 - 1;
            pointer.y = -((e.clientY) / height) * 2 + 1;

            // Convert normalized coords to world coordinates
            const vector = new THREE.Vector3(pointer.x, pointer.y, 0);
            vector.unproject(camera); // Convert to world space

            const cameraDirection = camera.getWorldDirection(new THREE.Vector3());

            positionX += (vector.x - oldVector.x) * (1 - Math.abs(cameraDirection.x));
            positionY += (vector.y - oldVector.y) * (1 - Math.abs(cameraDirection.y));
            positionZ += (vector.z - oldVector.z) * (1 - Math.abs(cameraDirection.z));

            buildingsTranslationXInput.set(positionX);
            buildingsTranslationYInput.set(positionY);
            buildingsTranslationZInput.set(positionZ);
            oldVector = vector;
        };

        window.addEventListener("mousemove", onMouseMove);

        const onMouseUp = () => {
            isDragging = false;
        };

        window.addEventListener("mouseup", onMouseUp);

        cleanUp.current = () => {
            mount.removeEventListener("mousedown", onMouseDown);
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    };

    const onMoveDeactivate = plot3d => {
        setMovementActive(false);
        plot3d.controls.enabled = true;
        if(cleanUp.current) {
            cleanUp.current();
            cleanUp.current = undefined;
        }
    };

    const toggleMovementActive = plot3d => {
        if(movementActive) {
            onMoveDeactivate(plot3d);
        } else {
            onMovementActive(plot3d);
        }
    };

    useEffect(() => () => {
        if(cleanUp.current) {
            cleanUp.current();
            cleanUp.current = undefined;
        }
    },[]);

    return {
        movementActive,
        toggleMovementActive,
    };
};